export default {
    toggleAppService: 18,
    toggleTransfersService: 19,
    toggleCardsService: 20,
    toggleUtilityBillsService: 21,
    toggleQrPaymentsService: 22,
    toggleRechargesService: 23,
    updateUserStatus: 24
};
